import { CrudConsumer, CrudConsumerObject } from "consumerjs";
import { API_KEY, getApiBaseEndpoint } from "./api";

/**
 * ThemeFilter.
 */
class ThemeFilter extends CrudConsumerObject {}

/**
 * ThemeFilter consumer.
 */
export class ThemeFilterConsumer extends CrudConsumer {
    constructor(
        endpoint = `${getApiBaseEndpoint()}/filtered-themes/`,
        objectClass = ThemeFilter,
        options = { csrfProtection: false }
    ) {
        super(endpoint, objectClass, options);

        this.addHeader("AUTHORIZATION", API_KEY);
    }

    /**
     * Sets the language.
     * @param {Object} language
     */
    setLanguage(language) {
        this.endpoint = `${getApiBaseEndpoint(language)}/filtered-themes/`;
    }

    /**
     * Sets the session header.
     * @param {Session} session
     */
    setSession(session) {
        this.addHeader("x-sessionid", session.session);
    }
}
